import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import ChangeOneTimePasswordForm from './ChangeOneTimePasswordForm.vue';
import IUpdatePasswordForm from '@/ui/views/updatepassword/updatepasswordform.interface';
import ChangeOneTimePasswordService from './changeonetimepassword.service';
import PageService from '@/core/page.service';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeOneTimePassword',
  props: {
    title: null,
    currentPasswordText: null,
    newPasswordText: null,
    confirmPasswordText: null,
    submitButtonText: null,
    contactInformationText: null
  },
  emits: ['updatePasswordSubmit'],
  setup(__props: any) {





const showSpinner = ref(false);
const errorMessage = ref<string>('');
const router = useRouter();

const updatePasswordSubmit = async(form: IUpdatePasswordForm) => {
    errorMessage.value = '';
    showSpinner.value = true;
    const destinationUrl = router.currentRoute.query.url as string;

    const serverResponse = await ChangeOneTimePasswordService.updatePassword(form, destinationUrl)
        .finally(() => showSpinner.value = false);
    if (serverResponse.passwordUpdateSuccess) {
        PageService.hardRedirect(serverResponse.redirectUrl);
    } else {
        errorMessage.value = serverResponse.errorMessage;
    }
};


return { __sfc: true,showSpinner, errorMessage, router, updatePasswordSubmit, ChangeOneTimePasswordForm }
}

})